import { StylesObject } from '../../types/styles'
import { SITE_VARIABLES, mq } from '../../themes/variables'

interface MatchupStylesObject extends StylesObject {
    title: StylesObject
    root: StylesObject
    header: StylesObject
    teamWrapper: StylesObject
    team: StylesObject
    logo: StylesObject
    teamName: StylesObject
    record: StylesObject
    contentWrapper: StylesObject
    content: StylesObject
}

export const getDefaultMatchupStylesObj = (
    siteVars: typeof SITE_VARIABLES,
    preview: boolean | undefined,
): MatchupStylesObject => {
    const { COLORS, TEXT_FONT_FAMILY } = siteVars

    return {
        title: {
            textAlign: 'center',
            margin: '1.5rem 0 -20px',
            fontWeight: '600',
            fontSize: '.8rem',
            color: COLORS.DARKGRAY,
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            ...(!preview && {
                [mq[2]]: {
                    fontSize: '1.2rem',
                },
            }),
        },
        root: {
            width: '100%',
            clear: 'both',
            margin: '1.5rem 0',
            borderTop: `0.25rem solid ${COLORS.GRAY}`,
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            color: COLORS.DARKGRAY,
        },
        header: {
            boxSizing: 'border-box',
            padding: '5px 0',
            ...(!preview && {
                [mq[2]]: {
                    display: 'flex',
                    height: '140px',
                },
            }),
        },
        teamWrapper: {
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '15px',
            '&.away': {
                borderBottom: `1px solid ${COLORS.GRAY}`,
            },
            ...(!preview && {
                [mq[2]]: {
                    flex: '1',
                    '&.away': {
                        borderBottom: 'none',
                        borderRight: `1px solid ${COLORS.GRAY}`,
                    },
                },
            }),
        },
        team: {
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
        },
        logo: {
            maxWidth: '45px',
            marginRight: '10px',
            img: {
                maxWidth: '45px',
            },
        },
        teamName: {
            display: 'block',
            textTransform: 'uppercase',
            fontWeight: '800',
            fontSize: '1rem',
            lineHeight: '1.1em',
            ...(!preview && {
                [mq[2]]: {
                    fontSize: '1.2rem',
                },
            }),
        },
        record: {
            color: COLORS.DARK,
            fontSize: '1rem',
            fontWeight: '800',
            whiteSpace: 'nowrap',
            lineHeight: '1.1',
            ...(!preview && {
                [mq[2]]: {
                    fontSize: '1.2rem',
                    paddingLeft: '10px',
                },
            }),
        },
        contentWrapper: {
            clear: 'both',
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            fontWeight: '700',
            padding: '5px 0',
            backgroundColor: COLORS.GRAY,
            color: COLORS.DARKGRAY,
            ...(!preview && {
                [mq[2]]: {
                    padding: '7px 0',
                    display: 'flex',
                    justifyContent: 'center',
                },
            }),
        },
        content: {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            fontSize: '.8rem',
            padding: '4px 2rem',
            ...(!preview && {
                [mq[2]]: {
                    padding: '4px 0',
                    fontSize: '1rem',
                },
            }),
        },
    }
}

export const getDivider = (
    siteVars: typeof SITE_VARIABLES,
    date?: string | null,
    channel?: string | null,
    odds?: string | null,
    preview?: boolean | number,
    time?: string | null,
): StylesObject => {
    const display = () => {
        if (time) return 'inline-block'
        if (date && (channel || odds)) return 'none'
        if (!date && !channel && !odds) return 'none'
        if (!date && channel && odds) return 'inline-block'
    }

    return {
        display: `${display()}`,
        content: '',
        borderRight: `1px solid ${siteVars.COLORS.MEDIUMGRAY}`,
        margin: '0 .5rem',
        ...(!preview && {
            [mq[2]]: {
                display: 'inline-block',
            },
        }),
    }
}
